export default {
  setShowLoadingSpinner: (state, showLoadingSpinner) => {
    if (showLoadingSpinner) {
      if (state.loadingSpinnerCount === 0) {
        state.showLoadingSpinner = true
      }
      state.loadingSpinnerCount++
    } else {
      state.loadingSpinnerCount--

      if (state.loadingSpinnerCount === 0) {
        state.showLoadingSpinner = false
      }
    }
  },
  setShowErrorMessage: (state, showErrorMessage) => {
    state.showErrorMessage = showErrorMessage
  },
  setShowUnauthorizedMessage: (state, showUnauthorizedMessage) => {
    state.showUnauthorizedMessage = showUnauthorizedMessage
    if (showUnauthorizedMessage === false) state.showErrorMessage = false
  },
  setShowValidationMessage: (state, showValidationMessage) => {
    state.showValidationMessage = showValidationMessage
    if (showValidationMessage === false) state.showErrorMessage = false
  }
}
